"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserMenuSeparator = exports.UserMenuItem = exports.UserMenu = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _utils = require("../utils");

var _withTheme = require("../../wrappers/with-theme");

var _withAuth = _interopRequireDefault(require("../../wrappers/with-auth"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var UserMenu = (0, _withAuth["default"])(function (_ref) {
  var _ref$user = _ref.user,
      user = _ref$user === void 0 ? {} : _ref$user,
      children = _ref.children;

  var _React$useState = _react["default"].useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      open = _React$useState2[0],
      setOpen = _React$useState2[1],
      clickedOutside = _react["default"].useCallback(function () {
    return setOpen(false);
  }, []),
      _useClickOutside = (0, _utils.useClickOutside)(clickedOutside),
      _useClickOutside2 = _slicedToArray(_useClickOutside, 1),
      setRef = _useClickOutside2[0],
      theme = (0, _withTheme.useTheme)();

  return !user.authed ? /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: "/auth/login"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n            flex items-center rounded cursor-pointer ".concat(theme.textInfo, "\n            border-transparent hover:").concat(theme.borderInfo, "\n            ").concat(theme.transition, " flex items-center justify-center\n          "),
    style: {
      width: "2.5rem",
      height: "2.5rem",
      borderRadius: "1.25rem",
      fontSize: "1.15rem",
      borderWidth: "3px"
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "fas fa-user"
  }))) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "relative",
    ref: setRef
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "\n            flex items-center rounded cursor-pointer ".concat(theme.textInfo, "\n            ").concat(open ? theme.borderInfo : "border-transparent", "\n            hover:").concat(theme.borderInfo, " ").concat(theme.transition, " flex items-center justify-center\n          "),
    style: {
      width: "2.5rem",
      height: "2.5rem",
      borderRadius: "1.25rem",
      fontSize: "1.15rem",
      borderWidth: "3px"
    },
    onClick: function onClick(e) {
      return setOpen(!open);
    }
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "fas fa-user"
  })), !open ? null : /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(theme.accent1, " mt-1 p-2 right-0 absolute ").concat(theme.text),
    style: {
      top: "100%",
      minWidth: "8rem"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "mb-1 border-b-2"
  }, user.email), children));
});
exports.UserMenu = UserMenu;

var UserMenuItem = function UserMenuItem(_ref2) {
  var _ref2$to = _ref2.to,
      to = _ref2$to === void 0 ? "#" : _ref2$to,
      children = _ref2.children;
  var theme = (0, _withTheme.useTheme)();
  return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, {
    to: to
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "rounded cursor-pointer px-2 ".concat(theme.transition, " hover:").concat(theme.accent2)
  }, children));
};

exports.UserMenuItem = UserMenuItem;

var UserMenuSeparator = function UserMenuSeparator() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "border-b-2 my-1"
  });
};

exports.UserMenuSeparator = UserMenuSeparator;